// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"164":"5d13e726","795":"23aa1e9a","884":"7266a0cc"}[chunkId] + ".css";
};